import React, { useState } from 'react';

import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

import BusinessUnitSelector from 'components/common/BusinessUnitsSelector';
import { FollowUpConfig } from 'services/types/followUpConfig';

import CreateFollowUpConfig from './components/CreateFollowUpConfig';
import SelectFollowUp from './components/SelectFollowUp';

interface SelectFollowUpProps {
  businessUnitId: number | null;
  selectFollowUp: (followUpId: FollowUpConfig) => void;
  setBusinessUnitId: (businessUnitId: number) => void;
}

type CampaignType = 'new' | 'existing';

const SelectOrCreateFollowUp = ({ businessUnitId, selectFollowUp, setBusinessUnitId }: SelectFollowUpProps) => {
  const [campaignType, setCampaignType] = useState<CampaignType>('existing');

  const handleCampaignTypeChange = (event: React.MouseEvent<HTMLElement>, newType: CampaignType) => {
    if (newType !== null) {
      setCampaignType(newType);
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" mb={4} ml={2}>
        <Box display="flex" flexDirection="column">
          <Typography variant="h6">1. Unidad de negocio</Typography>
          <Typography variant="body1">Para comenzar debes seleccionar una unidad de negocio</Typography>
        </Box>
        <Box ml={2}>
          <BusinessUnitSelector businessUnitId={businessUnitId} setBusinessUnitId={setBusinessUnitId} />
        </Box>
      </Box>

      {businessUnitId && (
        <Box mb={4} ml={2}>
          <Box display="flex" flexDirection="column" mb={2}>
            <Typography variant="h6">2. Tipo de campaña</Typography>
            <Typography variant="body1">
              Si ya tienes una campaña existente, puedes seleccionarla aquí. Si no, puedes crear una nueva.
            </Typography>
          </Box>
          <ToggleButtonGroup
            value={campaignType}
            exclusive
            onChange={handleCampaignTypeChange}
            aria-label="campaign type"
          >
            <ToggleButton value="existing" aria-label="campaña existente">
              Campaña existente
            </ToggleButton>
            <ToggleButton value="new" aria-label="nueva campaña">
              Nueva campaña
            </ToggleButton>
          </ToggleButtonGroup>
          <Box mt={2}>
            {campaignType === 'existing' && (
              <SelectFollowUp businessUnitId={businessUnitId} selectFollowUp={selectFollowUp} />
            )}
            {campaignType === 'new' && (
              <CreateFollowUpConfig businessUnitId={businessUnitId} selectFollowUp={selectFollowUp} />
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default SelectOrCreateFollowUp;
